import { Injectable, inject } from '@angular/core';
import { ActivityInfo } from '../calendars/calendars.models';
import { ActivityAssignInfo, Campaign, CampaignActivities } from './campaigns.models';
import { Observable } from 'rxjs';
import { DataHandlerService } from '../../shared/services/data-handler.service';
import { ConfigurationService } from '../../shared/services/configuration.service';
import { SaveResult } from '../../shared/models/result.model';



@Injectable({ providedIn: 'root' })

export class CampaignsService
{
  private dataHandler = inject(DataHandlerService);
  public configurationService = inject(ConfigurationService);


  constructor()
  {

  }








  getUnassignedCampaignActivities(id: number, useCachedData: boolean = false): Observable<ActivityInfo[]>
  {
    return this.dataHandler.getHttpObservable<ActivityInfo[]>(this.configurationService.cbSettings().campaignServiceUrl + "/GetUnassignedCampaignActivities?id=" + id, useCachedData, false);
  }

  getCampaignActivities(campaignId: number, useCachedData: boolean = false): Promise<ActivityInfo[]>
  {
    return this.dataHandler.getHttpPromise<ActivityInfo[]>(this.configurationService.cbSettings().campaignServiceUrl + "/GetCampaignActivities?id=" + campaignId, useCachedData, false);
  }

  getUnassignedActivitiesForClient(clientId: number, useCachedData: boolean = false): Promise<ActivityInfo[]>
  {
    return this.dataHandler.getHttpPromise<ActivityInfo[]>(this.configurationService.cbSettings().campaignServiceUrl + "/GetUnassignedActivitiesForClient?id=" + clientId, useCachedData, false);
  }


  assignActivitiesToCampaign(campaignActivities: CampaignActivities, useCachedData: boolean = false): Promise<SaveResult>
  {
    return this.dataHandler.postHttpPromise<SaveResult>(this.configurationService.cbSettings().campaignServiceUrl + "/AssignActivitiesToCampaign", campaignActivities, useCachedData, false);
  }

  unassignActivityFromCampaign(activityAssignInfo: ActivityAssignInfo, useCachedData: boolean = false): Promise<SaveResult>
  {
    return this.dataHandler.postHttpPromise<SaveResult>(this.configurationService.cbSettings().campaignServiceUrl + "/UnassignActivityFromCampaign", activityAssignInfo, useCachedData, false);
  }



}
